import { DocumentProvider } from '../context';
interface BudgetGuidesProps {
  children?: React.ReactNode;
}
export function GuidesContainer({ children }: BudgetGuidesProps) {
  return <DocumentProvider>{children}</DocumentProvider>;
}
